'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('technicaltermsFormCtrl', ['$scope', '$http', '$log', '$sce', function($scope, $http, $log, $sce){
	$scope.sumbitted = false;
	$scope.message = '';
	$scope.nrCheckUrl = technicaltermsData.data_url;
	$scope.check_registration_nr = '';
	$scope.checking_nr = false;
	$scope.loading = false;

	$scope.onChange = function(){
		if (typeof $scope.check_registration_nr !== 'undefined') {
			$scope.check_registration_nr = $scope.check_registration_nr.replace(/[^0-9a-z]/ig, '').substring(0, 7).replace(/^(.{2})(.+)$/i, '$1-$2');
		}
	};

	$scope.checkRegNr = function(check_registration_nr){
		$scope.checking_nr = true;
		if($scope.nrCheckUrl !== '' && check_registration_nr !== ''){
			$http({
				method: 'POST',
				url: $scope.nrCheckUrl,
				data: {
					nr: check_registration_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function(response){
				$scope.submitted = true;
				$scope.regNrValid = response.data.success;
				if(response.data.message) {
					$scope.message = $sce.trustAsHtml(response.data.message);
				}
			}, function(response){
				console.log(['Error', response]);
			}).then(function(){
				$scope.checking_nr = false;
			});
		}
	};
}]);